import { reactive } from 'vue'

export const store = reactive({
  path: process.env.VUE_APP_API_URL,
  reloadPath(path) {
    this.path = path
  }
})